import React from 'react'
import { Button, Col } from 'react-bootstrap'
import CostFilter from './filter/CostFilter'
import CuisineFilter from './filter/CuisineFilter'
import SortFilter from './filter/SortFilter'


const Filter = ({ locations }) => {



    return (
        <React.Fragment>
            <Col sm={12} md={4} lg={3} className="me-5 p-3 border">
                <h4>Filters</h4>
                <div className="location mt-4">
                    <h6>Select Location</h6>
                    <select name="location" id="location">
                        <option value="malad">Select Location</option>
                        {
                            locations.map((location, index) => {
                                return (
                                    <option value={location.location_id} key={location.location_id}>
                                        {location.state}
                                    </option>
                                )
                            })
                        }
                    </select>
                </div>

                <CuisineFilter />

                <CostFilter />

                <SortFilter />
                <div className="apply d-md-none mt-3">
                    <Button className='btn-danger w-100'>Apply</Button>
                </div>
            </Col>
        </React.Fragment>
    )
}

export default Filter